import { defineMessage } from 'services/localization';

export const messages = {
    addUser: defineMessage('add_user_1'),
    addNewUser: defineMessage('add_a_new_user'),
    description: defineMessage('type_in_the_email_addre_he_user_you_want_to_add'),
    emailPlaceholder: defineMessage('useremailcom'),
};
